var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shouldRender)?_c('div',{staticClass:"advert mt-3 mb-3"},[_c('ins',{staticClass:"adsbygoogle",style:(_vm.adStyle),attrs:{"data-ad-client":_vm.client,"data-ad-slot":_vm.slot,"data-ad-format":_vm.adFormat,"data-full-width-responsive":"true"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }